import './styles.scss'
import React from 'react'
// import Buttoninput from './components/buttoninput.js'
// import Businesscard from './components/businesscard.js'
export default function App() {
  return (
    <>
      <header></header>
      <main>
        <div className="business-card">
          <h1>Dennis John</h1>
          <h3>
            Business Development | Strategy & Expansion | Digital Solutions
          </h3>
          <p>dennis@john.international</p>
        </div>
      </main>
    </>
  )
}
